import React from "react"
import Whatsapp from "../Icons/Whatsapp"
import AgregarMensajeWhatsapp from "../../../utils/AgregarMensajeWhatsapp"
import "./BotonWhatsappFlotante.scss"

const BotonWhatsappFlotante = ({ href, className = "", mensaje = "" }) => {
  if (!href) return null

  const finalHref = mensaje ? AgregarMensajeWhatsapp(href, mensaje) : href

  return (
    <a
      href={finalHref}
      target="_blank"
      rel="noreferrer"
      aria-label="Escríbenos por WhatsApp"
      className={`boton-whatsapp-flotante ${className}`}
    >
      <Whatsapp />
    </a>
  )
}

export default BotonWhatsappFlotante
